import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { debounce } from "lodash";
import { Breadcrumb, Input, Table, Space, Popconfirm, Row } from "antd";
import SearchIcon from "../../image/SearchIcon.svg";
import { getRequest, postRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";

const { Search } = Input;

const ArchiveactivityLog = () => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [archivedeliveryList, setArchiveDeliveryList] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [selectedRow, setSelectedRow] = useState([]);
  const [reload, setReload] = useState(false);

  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });

  useEffect(() => {
    const getArchiveActivityLogList = async () => {
      setLoading(true);

      try {
        let apiResponse = await getRequest("delivery-address-archive/", state);
        if (apiResponse.status) {
          setArchiveDeliveryList(apiResponse.data.results);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_archive_list"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getArchiveActivityLogList();
  }, [state, reload, t]);

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "company_name" && sortOrder === "ascend") {
      sortingEnumKey = "company_name";
    }
    if (sortField === "company_name" && sortOrder === "descend") {
      sortingEnumKey = "-company_name";
    }
    if (sortField === "person_name" && sortOrder === "ascend") {
      sortingEnumKey = "person_name";
    }
    if (sortField === "person_name" && sortOrder === "descend") {
      sortingEnumKey = "-person_name";
    }
    if (sortField === "email" && sortOrder === "ascend") {
      sortingEnumKey = "email";
    }
    if (sortField === "email" && sortOrder === "descend") {
      sortingEnumKey = "-email";
    }
    if (sortField === "email" && sortOrder === "ascend") {
      sortingEnumKey = "email";
    }
    if (sortField === "email" && sortOrder === "descend") {
      sortingEnumKey = "-email";
    }
    if (sortField === "phone" && sortOrder === "ascend") {
      sortingEnumKey = "phone";
    }
    if (sortField === "phone" && sortOrder === "descend") {
      sortingEnumKey = "-phone";
    }
    if (sortField === "country" && sortOrder === "ascend") {
      sortingEnumKey = "country";
    }
    if (sortField === "country" && sortOrder === "descend") {
      sortingEnumKey = "-country";
    }
    if (sortField === "detail" && sortOrder === "ascend") {
      sortingEnumKey = "detail";
    }
    if (sortField === "detail" && sortOrder === "descend") {
      sortingEnumKey = "-detail";
    }
    if (sortField === "ip_address" && sortOrder === "ascend") {
      sortingEnumKey = "ip_address";
    }
    if (sortField === "ip_address" && sortOrder === "descend") {
      sortingEnumKey = "-ip_address";
    }
    if (sortField === "log_time" && sortOrder === "ascend") {
      sortingEnumKey = "log_time";
    }
    if (sortField === "log_time" && sortOrder === "descend") {
      sortingEnumKey = "-log_time";
    }

    return sortingEnumKey;
  };

  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };
  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);
  const rowSelection = {
    onChange: (selectedRowKeys) => {
      setSelectedRow(selectedRowKeys);
    },
  };

  const handleRestore = async (id = "") => {
    let ids = selectedRow;
    if (ids.length === 0) {
      ids.push(id);
    }

    try {
      let apiResponse = await postRequest("delivery-address-archive/", {
        deleted: ids,
      });
      if (apiResponse.data.success) {
        SuccessNotificationMsg(t("activity_log_restore_successfully"));
        setReload(!reload);
        setSelectedRow([]);
      } else {
        ErrorNotificationMsg(t("error_in_restore_activity_log"));
      }
    } catch (error) {
      ErrorNotificationMsg(error);
    }
  };

  const columns = [
    {
      title: "Company Name",
      dataIndex: "company_name",
      key: "company_name",
      sorter: true,
    },
    {
      title: "Person Name",
      dataIndex: "person_name",
      sorter: true,
      key: "person_name",
    },
    {
      title: "Email",
      dataIndex: "email",
      sorter: true,
      key: "email",
    },
    {
      title: "Phone Or Whatsapp Number",
      dataIndex: "phone",
      render: (phone) => <>+{phone} </>,
      sorter: true,
      key: "phone",
    },
    {
      title: "Country",
      dataIndex: "country",
      sorter: true,
      key: "country",
    },

    {
      title: "Detail",
      dataIndex: "detail",
      sorter: true,
      key: "detail",
    },
    {
      title: "IP Address",
      dataIndex: "ip_address",
      sorter: true,
      key: "ip_address",
    },
    {
      title: "Log Time",
      dataIndex: "log_time",
      sorter: true,
      key: "log_time",
    },
  ];

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>{t("pl_archive_activity_log")}</h3>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/activity-log">{t("pl_activity_log")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("pl_Archive")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
                <Search
                  prefix={
                    <img
                      src={SearchIcon}
                      alt="SearchIcon"
                      className="SearchIcon"
                      width={22}
                    />
                  }
                  placeholder={t("pl_search_list")}
                  onChange={searchCallbackDelayed}
                  style={{
                    width: 250,
                  }}
                />
              </Space>
            </div>
            {selectedRow.length > 0 && (
              <Popconfirm
                className="action"
                title={t("pop_restore_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                placement="left"
                onConfirm={() => handleRestore()}
              >
                <ButtonField
                  className="BlueShadowBtn"
                  type="primary"
                  htmlType="button"
                  label={t("pl_restore")}
                />
              </Popconfirm>
            )}
          </Space>
        </div>
      </div>

      <section className="grid-sec mt-5 tablegridsec">
        <div className="PR-body">
          <Row className="tblheader">
            {/* <Col xs={24} sm={24} md={12} lg={12} xl={12} className="tbl-heading">
            <h1>{t("pl_archive_activity_log")}</h1>
          </Col> */}
            {/* <Col xs={24} sm={24} md={12} lg={12} xl={12} className="tbl-action">
            <div className="searchwrp">
              <Space direction="vertical">
                <Search
                  prefix={
                    <img
                      src={SearchIcon}
                      alt="SearchIcon"
                      className="SearchIcon"
                      width={22}
                    />
                  }
                  placeholder={t("pl_search_list")}
                  onChange={searchCallbackDelayed}
                  style={{
                    width: 250,
                  }}
                />
              </Space>
            </div>
            {selectedRow.length > 0 && (
              <Popconfirm
                className="action"
                title={t("pop_restore_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                placement="left"
                onConfirm={() => handleRestore()}
              >
                <ButtonField
                  className="BlueShadowBtn"
                  type="primary"
                  htmlType="button"
                  label={t("pl_restore")}
                />
              </Popconfirm>
            )}
          </Col> */}
          </Row>
<div className="tablewrp">
          <Table
            scroll={{
              x: 1500,
            }}
            rowSelection={rowSelection}
            columns={columns}
            rowKey={(record) => record.id}
            dataSource={archivedeliveryList}
            loading={loading}
            pagination={{
              defaultCurrent: state.page,
              defaultPageSize: state.pagesize,
              total: totalCount,
              showSizeChanger: true,
              showTotal: (total) => `Total ${total} items`,
            }}
            onChange={handleTableChange}
          />
          </div>
        </div>
      </section>
    </>
  );
};

export default ArchiveactivityLog;
